
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search/train/europe",
      function () {
        return require("private-next-pages/search/train/europe/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/search/train/europe"])
      });
    }
  